var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8524",
    "data-name": "Group 8524",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.786,
    height: 64.069,
    viewBox: "0 0 62.786 64.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M451.866,230.705a1.347,1.347,0,0,0,.006.211l-4.826,4.05-1.439-.521-1.07,2.069,3.146,1.5,5.276-5.92a1.333,1.333,0,1,0-1.093-1.386Z",
    transform: "translate(-428.615 -219.738)",
    fill: "#a0616a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M401.622,264.543l-4.66-1.682a1.715,1.715,0,0,1,1.164-3.226l4.66,1.682a.571.571,0,0,1,.344.732h0l-.776,2.151a.572.572,0,0,1-.732.344Z",
    transform: "translate(-384.844 -246.775)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M419.314,417.385h1.557l.741-6.007h-2.3Z",
    transform: "translate(-405.948 -383.231)",
    fill: "#a0616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M420.916,468.15h-4.895v-1.891h3a1.891,1.891,0,0,1,1.891,1.891Z",
    transform: "translate(-402.989 -432.55)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M381.34,407.227l1.274.9,4.061-4.488-1.88-1.322Z",
    transform: "translate(-371.823 -375.085)",
    fill: "#a0616a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M372.929,446.65l-4-2.814,1.087-1.547,2.457,1.727A1.891,1.891,0,0,1,372.929,446.65Z",
    transform: "translate(-360.667 -411.009)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M406.108,363.593s3.887-.459,3.189,2.063-8.471,4.7-8.471,4.7Z",
    transform: "translate(-389.334 -340.26)",
    fill: "#a0616a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 3.12,
    cy: 3.12,
    r: 3.12,
    transform: "translate(10.979 4.225)",
    fill: "#a0616a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M314.976,264.73a5.381,5.381,0,0,1,.435-7.879,9.333,9.333,0,0,1,2.348-1.559l2.282-6.381a3.477,3.477,0,0,1,3.214-2.312,3.328,3.328,0,0,1,3.228,2.076,2.889,2.889,0,0,1,.09,2.046,32.858,32.858,0,0,1-2.662,6.091l.118.944,5.768.513-.054.087a34.887,34.887,0,0,1-6.462,7.2,5.934,5.934,0,0,1-3.717,1.38A6.157,6.157,0,0,1,314.976,264.73Z",
    transform: "translate(-310.827 -235.15)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M291.042,141.984a5.462,5.462,0,0,0,.979-2.355,14.019,14.019,0,0,1,1.2-3.877,3.757,3.757,0,0,1,3.256-2.087,3.823,3.823,0,0,1,3.018,2.394,1.074,1.074,0,0,1,.872.042.793.793,0,0,1,.226,1.2,2.882,2.882,0,0,1,2.347-.058,2.837,2.837,0,0,1,1.719,2.408,1.547,1.547,0,0,1-.411,1.16c-.6.616-1.445.4-2.2.247-.711-.148-1.577-.188-1.978.489a1.27,1.27,0,0,0-.124.928,3.275,3.275,0,0,0,1.14,1.6l.079.148a3.488,3.488,0,0,1-1.792-6.726h0a.618.618,0,0,1-.555-.927,2.941,2.941,0,0,0-1.5-.375,2.727,2.727,0,0,0-2.039,1.4,8.429,8.429,0,0,0-.85,2.413,7.405,7.405,0,0,1-.9,2.392,3.806,3.806,0,0,1-6.1.313A3.037,3.037,0,0,0,291.042,141.984Z",
    transform: "translate(-287.438 -133.661)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12072",
    "data-name": "Path 12072",
    d: "M525.6,229.78a3.933,3.933,0,1,1,3.933-3.933A3.933,3.933,0,0,1,525.6,229.78Zm0-7.211a3.278,3.278,0,1,0,3.277,3.278,3.278,3.278,0,0,0-3.277-3.278Z",
    transform: "translate(-497.927 -212.969)",
    fill: "#fff56d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12073",
    "data-name": "Path 12073",
    d: "M556.293,172.979a.328.328,0,0,1-.328-.328v-3.769a.328.328,0,0,1,.656,0v3.769A.328.328,0,0,1,556.293,172.979Z",
    transform: "translate(-528.75 -165.018)",
    fill: "#fff56d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12074",
    "data-name": "Path 12074",
    d: "M472.4,256.869h-3.769a.328.328,0,1,1,0-.656H472.4a.328.328,0,1,1,0,.656Z",
    transform: "translate(-449.976 -243.792)",
    fill: "#fff56d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12075",
    "data-name": "Path 12075",
    d: "M608.227,256.869h-3.769a.328.328,0,0,1,0-.656h3.769a.328.328,0,1,1,0,.656Z",
    transform: "translate(-572.033 -243.792)",
    fill: "#fff56d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12076",
    "data-name": "Path 12076",
    d: "M603.436,207.931a.328.328,0,0,1-.228-.563l1.578-1.531a.328.328,0,1,1,.456.471l-1.578,1.531A.326.326,0,0,1,603.436,207.931Z",
    transform: "translate(-571.114 -198.439)",
    fill: "#fff56d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12077",
    "data-name": "Path 12077",
    d: "M494.467,207.931a.327.327,0,0,1-.228-.092l-1.578-1.531a.328.328,0,0,1,.456-.471l1.578,1.531a.328.328,0,0,1-.228.563Z",
    transform: "translate(-471.772 -198.439)",
    fill: "#fff56d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12078",
    "data-name": "Path 12078",
    d: "M496.123,295.47a.328.328,0,0,1-.235-.556l1.578-1.625a.328.328,0,1,1,.47.457l-1.578,1.625A.328.328,0,0,1,496.123,295.47Z",
    transform: "translate(-474.678 -277.021)",
    fill: "#fff56d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12079",
    "data-name": "Path 12079",
    d: "M605.343,295.8a.326.326,0,0,1-.234-.1l-1.906-1.953a.328.328,0,1,1,.469-.458l1.906,1.953a.328.328,0,0,1-.235.557Z",
    transform: "translate(-571.115 -277.022)",
    fill: "#fff56d"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12080",
    "data-name": "Path 12080",
    d: "M556.293,312.036a.328.328,0,0,1-.328-.328v-3.769a.328.328,0,0,1,.656,0v3.769A.328.328,0,0,1,556.293,312.036Z",
    transform: "translate(-528.75 -289.981)",
    fill: "#fff56d"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M437.68,278.651a1.339,1.339,0,0,0-.084.193l-6.089,1.615-1.081-1.083-1.848,1.418,2.211,2.693,7.291-3.116a1.333,1.333,0,1,0-.4-1.719Z",
    transform: "translate(-414.273 -263.326)",
    fill: "#a0616a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M396.551,261.437l-3.5-3.5a1.715,1.715,0,0,1,2.425-2.425h0l3.5,3.5a.572.572,0,0,1,0,.808h0l-1.617,1.617a.573.573,0,0,1-.809,0Z",
    transform: "translate(-381.893 -242.708)",
    fill: "#ccc"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12081",
    "data-name": "Path 12081",
    d: "M350.679,423.013H314.387a14.44,14.44,0,0,1,0-28.877h2.582a17.606,17.606,0,0,1,6.328-7.083,17.155,17.155,0,0,1,9.237-2.7,17.552,17.552,0,0,1,17.353,16.309h.793a11.178,11.178,0,0,1,0,22.353Zm-36.292-28.268a13.832,13.832,0,0,0,0,27.66h36.292a10.57,10.57,0,0,0,0-21.137h-1.363l-.017-.286a16.736,16.736,0,0,0-31.865-6.411l-.083.173Z",
    transform: "translate(-298.896 -358.944)",
    fill: "#0086e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedLocation);
export default __webpack_public_path__ + "static/media/feedLocation.d3dcec4a4aaecd723d1616c7bdaffb95.svg";
export { ForwardRef as ReactComponent };